import styled from '@emotion/styled';

import { authColors } from '../tokens';

import { StepStatus } from './types';

export const spec = {
  icon: { size: 28 },
  currentDot: { size: 22, border: 2 },
  check: { size: 12 },
  step: { width: 108, height: 80 },
  connector: { height: 3 },
} as const;

const iconBackground: Record<StepStatus, string> = {
  pendente: authColors.track,
  'em-processo': authColors.brand,
  concluida: authColors.success,
};

const statusColor: Record<StepStatus, string> = {
  pendente: authColors.disabled,
  'em-processo': authColors.brand,
  concluida: authColors.success,
};

export const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: 647px;
  height: ${spec.step.height}px;
`;

export const Journey = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  max-width: 647px;
`;

export const Cards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: ${authColors.white};
  border-radius: 12px;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  height: 74px;
  padding: 19px 24px;
`;

export const CardDivider = styled.hr`
  width: 100%;
  margin: 0;
  border: none;
  border-top: 1px dashed ${authColors.disabled};
`;

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  padding: 18px 16px 24px;
`;

export const StepRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const Connector = styled.div<{ index: number }>`
  position: absolute;
  top: 20%;
  height: ${spec.connector.height}px;
  background: ${authColors.track};
  border-radius: 4px;
  overflow: hidden;

  ${({ index }) =>
    index === 0 ? `left: 7.42%; right: 61.51%;` : `left: 49%; right: 19.94%;`}
`;

export const ConnectorFill = styled.div<{ ratio: number; done: boolean }>`
  height: 100%;
  width: ${({ ratio }) => Math.round(ratio * 100)}%;
  background: ${({ done }) => (done ? authColors.success : authColors.brand)};
  border-radius: 4px;
`;

export const Step = styled.div<{ index: number }>`
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: ${spec.step.width}px;

  ${({ index }) => {
    if (index === 0) return `left: 0;`;
    if (index === 1) return `left: 41.58%;`;
    return `left: 83.15%;`;
  }}
`;

export const IconStep = styled.div<{ status: StepStatus }>`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  flex-shrink: 0;
  width: ${spec.icon.size}px;
  height: ${spec.icon.size}px;
  background: ${({ status }) => iconBackground[status]};
  border-radius: 100px;
`;

export const CurrentDot = styled.div`
  flex-shrink: 0;
  box-sizing: border-box;
  width: ${spec.currentDot.size}px;
  height: ${spec.currentDot.size}px;
  background: ${authColors.brand};
  border: ${spec.currentDot.border}px solid ${authColors.white};
  border-radius: 1000px;
`;

export const CheckIcon = styled.svg`
  flex-shrink: 0;
  width: ${spec.check.size}px;
  height: ${spec.check.size}px;
  color: ${authColors.textStrong};
`;

export const NameStep = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  height: 36px;
`;

export const StepLabel = styled.span`
  display: flex;
  align-items: center;
  align-self: stretch;
  height: 16px;
  font-family: 'Mangueira', sans-serif;
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
  color: ${authColors.textMuted};
`;

export const StepTexts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StepName = styled.span`
  display: flex;
  align-items: center;
  height: 20px;
  font-family: 'Mangueira', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: ${authColors.textStrong};
  white-space: nowrap;
`;

export const StepStatusText = styled.span<{ status: StepStatus }>`
  font-family: 'Mangueira', sans-serif;
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
  color: ${({ status }) => statusColor[status]};
`;
